'use es6';

import { SEND } from 'FormsUI/constants/NotificationPreferences';
const getRoot = state => state.notificationPreferences;
export const getNotificationPreferences = state => getRoot(state).preferences || {};
export const getAreEmailNotificationsDisabled = state => {
  const {
    settings: {
      EMAIL
    } = {}
  } = getNotificationPreferences(state);
  return EMAIL && EMAIL !== SEND;
};
export const getNotificationPreferencesRequestState = state => getRoot(state).requestState;